<template>
  <v-dialog :model-value="modelValue" max-width="700" persistent @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="text-h6 d-flex align-center">
        <v-icon left>mdi-upload</v-icon>
        导入操作记录
        <v-spacer />
        <span class="text-body-2 text-grey">共 {{ records.length }} 条</span>
      </v-card-title>
      <v-divider />
      <v-card-text style="max-height: 50vh; overflow-y: auto;">
        <div v-if="records.length === 0" class="text-center text-grey py-6">
          文件中没有可导入的操作记录
        </div>
        <template v-else>
          <div class="d-flex align-center mb-2">
            <v-checkbox
              :model-value="allSelected"
              :indeterminate="someSelected"
              label="全选"
              density="compact"
              hide-details
              @update:model-value="toggleSelectAll"
            />
            <v-spacer />
            <span class="text-body-2 text-grey">已选 {{ selectedIndexes.length }} 条</span>
          </div>
          <v-divider class="mb-2" />
          <v-list density="compact" class="py-0">
            <v-list-item
              v-for="(rec, idx) in records"
              :key="idx"
              class="px-0"
            >
              <template v-slot:prepend>
                <v-checkbox
                  :model-value="selectedIndexes.includes(idx)"
                  density="compact"
                  hide-details
                  @update:model-value="toggleItem(idx)"
                />
              </template>
              <v-list-item-title>
                {{ rec.operationName || '(未命名)' }}
                <span v-if="rec.emoji" class="ml-1">{{ rec.emoji }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                版本: {{ rec.version ?? '-' }} · 设备型号: {{ rec.servoVersion ?? '-' }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </template>
        <v-progress-linear v-if="importing" indeterminate class="mt-3" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-3">
        <v-btn variant="outlined" :disabled="importing" @click="$emit('update:modelValue', false)">取消</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          variant="outlined"
          :loading="importing"
          :disabled="selectedIndexes.length === 0"
          @click="$emit('confirm', 'selected')"
        >
          导入选中 ({{ selectedIndexes.length }})
        </v-btn>
        <v-btn
          color="teal"
          variant="flat"
          :loading="importing"
          :disabled="records.length === 0"
          @click="$emit('confirm', 'all')"
        >
          导入全部 ({{ records.length }})
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  records: { type: Array, default: () => [] },
  selectedIndexes: { type: Array, default: () => [] },
  importing: { type: Boolean, default: false }
})
const emit = defineEmits(['update:modelValue', 'update:selectedIndexes', 'confirm'])

const allSelected = computed(() =>
  props.records.length > 0 && props.selectedIndexes.length === props.records.length
)
const someSelected = computed(() =>
  props.selectedIndexes.length > 0 && props.selectedIndexes.length < props.records.length
)

const toggleSelectAll = () => {
  emit('update:selectedIndexes', allSelected.value ? [] : props.records.map((_, idx) => idx))
}

const toggleItem = (idx) => {
  const next = [...props.selectedIndexes]
  const pos = next.indexOf(idx)
  if (pos === -1) {
    next.push(idx)
  } else {
    next.splice(pos, 1)
  }
  emit('update:selectedIndexes', next)
}
</script>
